import { useState } from 'react'

const useDetailEditMode = createMode => {
  const [detailEditMode, setDetailEditMode] = useState(createMode)

  return {
    detailEditMode,
    setDetailEditMode
  }
}

export default useDetailEditMode
